export const NEW_NOTIFICATION = (authUserId: string) => ({
  eventType: 'new-notification',
  channelName: `private-user-${authUserId}`
});
